import {
  isPersonalAuthorization,
  isSsoAuthorization,
  SsoAuthorization,
} from 'graphql/multisession'
import { isSSOWorkspace } from 'modules/workspace/utils'
import { useUserAuthorizations } from './useUserAuthorizations'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'

export const useCheckCurrentAuthorizationForWorkspace = () => {
  const { activeAuthorization } = useUserAuthorizations()

  const checkAuthorization = function (
    workspace: Pick<WorkspaceMinimalFragment, 'identifier' | 'customer'>
  ) {
    const isCurrentWorkspaceSSO = isSSOWorkspace(workspace)
    const isLoggedInWithSSOAuth = isSsoAuthorization(activeAuthorization)
    const isLoggedInWithPersonalAuth = isPersonalAuthorization(
      activeAuthorization
    )

    if (isCurrentWorkspaceSSO) {
      const currentSSOAuthorization = activeAuthorization as SsoAuthorization

      return isLoggedInWithSSOAuth
        ? currentSSOAuthorization.workspaceId === workspace.identifier
        : false
    }

    if (isLoggedInWithPersonalAuth) {
      return true
    }

    return false
  }

  return { checkAuthorization }
}
